"use client";
import * as React from "react";
import Image from "next/image";
import useTranslations from "@/i18n/useTranslations";

// only static data is used in this component
export default function AboutEdx() {
  const t = useTranslations("Homepage");
  const headerClassName = "font-bold text-primary mb-1 text-lg";
  return (
    <div className="py-16 w-full">
      <div className="flex flex-row text-balance py-4 px-8 container w-full">
        <div className="md:basis-1/2">
          <p>
            {t("aboutEdxIntroBefore")}{" "}
            <span className="font-bold">{t("aboutEdxIntroBold")}</span>.
          </p>
          <div>
            <div className="flex flex-col md:flex-row">
              <div className="md:basis-1/2">
                <p className={headerClassName}>{t("aboutEdxPropelling")}</p>
                <p>{t("aboutEdxPropellingDesc")}</p>
              </div>
              <div className="md:basis-1/2">
                <p className={headerClassName}>{t("aboutEdxConvenient")}</p>
                <p>{t("aboutEdxConvenientDesc")}</p>
              </div>
            </div>
            <div className="flex flex-col md:flex-row">
              <div className="md:basis-1/2">
                <p className={headerClassName}>{t("aboutEdxFlexible")}</p>
                <p>{t("aboutEdxFlexibleDesc")}</p>
              </div>
              <div className="md:basis-1/2">
                <p className={headerClassName}>{t("aboutEdxSupportive")}</p>
                <p>{t("aboutEdxSupportiveDesc")}</p>
              </div>
            </div>
          </div>
        </div>
        <div className="md:basis-1/2 flex justify-center align-center hidden md:block">
          <Image
            className="mr-2"
            width={400}
            height={312}
            src={"/images/world_map.webp"}
            alt={t("aboutEdxAlt")}
          />
        </div>
      </div>
    </div>
  );
}
